export const SIGNUP_REQUEST = "SIGNUP_REQUEST";
export const SIGNUP_SUCCESS = "SIGNUP_SUCCESS";
export const SIGNUP_FAILURE = "SIGNUP_FAILURE";
export const USER_ALREADY_REGISTERED = "USER_ALREADY_REGISTERED";

export const LOGIN_REQUEST = "LOGIN_REQUEST";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAILURE = "LOGIN_FAILURE";
export const VERIFY_OTP_REQUEST = "VERIFY_OTP_REQUEST";
export const LOGOUT = "LOGOUT";
export const CLEAR_ERROR = "CLEAR_ERROR";
export const UPDATE_STUDENT_ID = 'UPDATE_STUDENT_ID';
export const UPDATE_TUTOR_ID = 'UPDATE_TUTOR_ID';
export const UPDATE_INSTITUTION_ID = 'UPDATE_INSTITUTION_ID';

export const FETCH_PROFILE_DATA_REQUEST = "FETCH_PROFILE_DATA_REQUEST";
export const FETCH_PROFILE_DATA_SUCCESS = "FETCH_PROFILE_DATA_SUCCESS";
export const FETCH_PROFILE_DATA_FAILURE = "FETCH_PROFILE_DATA_FAILURE";

export const SET_NOTIFICATIONS = "SET_NOTIFICATIONS";
export const FETCH_NOTIFICATIONS_REQUEST = "FETCH_NOTIFICATIONS_REQUEST";
export const FETCH_NOTIFICATIONS_SUCCESS = "FETCH_NOTIFICATIONS_SUCCESS";
export const FETCH_NOTIFICATIONS_FAILURE = "FETCH_NOTIFICATIONS_FAILURE";

export const USER_DATA_REQUEST = "USER_DATA_REQUEST";
export const USER_DATA_SUCCESS = "USER_DATA_SUCCESS";
export const USER_DATA_FAILURE = "USER_DATA_FAILURE";